import { SensorTypeEnum } from '@/types/sensor/sensors';

import { Step } from '../../SensorEditingContext';
import { commonDetectionStep, commonGeneralStep, commonLocalizationStep, commonMonitoringStep } from '../common';
import { AeroscopeAuthentForm, AeroscopeConnectivityForm } from './AeroscopeForms';

export const aeroscopeSteps: Step<SensorTypeEnum.AEROSCOPE>[] = [
  commonGeneralStep,
  commonLocalizationStep,
  {
    label: 'connectivity',
    component: AeroscopeConnectivityForm,
    validationFields: ['host', 'port', 'timeoutThreshold', 'controlUrl'],
  },
  {
    label: 'aeroscope.authent',
    component: AeroscopeAuthentForm,
    validationFields: ['username', 'password'],
  },
  commonDetectionStep,
  commonMonitoringStep,
];
